export default __webpack_public_path__ + "static/Footer_background-abe677a8fe525ce56bfa601aed21f73a.svg";